import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import baseQueryWithReauth from './base';
import PaywaySite from '../../types/PaywaySite';

export interface InstallmentOption {
  installments: number;
  interest_rate: number;
  promotion_id: string | null;
  promotion_name: string | null;
  // Site por el que se cobra esta opción. Falta en un backend viejo: default.
  payway_site?: PaywaySite;
}

export interface BinData {
  id?: string;
  bin: string;
  scheme: string;
  type: string;
  issuer: string | null;
  tier: string | null;
  country: string | null;
  created_at?: string;
  updated_at?: string | null;
  deleted_at?: string | null;
  payway_code: number | null;
  allowed_installments: number[];
  installment_options?: InstallmentOption[];
}

const binsApi = createApi({
  reducerPath: 'binsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['bins'],
  endpoints: (build) => ({
    getBinData: build.query<BinData | null, { bin: string; eventId?: string }>({
      query: ({ bin, eventId }) => ({
        url: `/bins/${bin}`,
        method: 'GET',
        params: eventId ? { event_id: eventId } : undefined,
      }),
      transformResponse: (response: Response<BinData>): (BinData | null) => response.data || null,
    }),
  }),
});

export const {
  useGetBinDataQuery,
  useLazyGetBinDataQuery,
} = binsApi;

export { binsApi };
